export default "__VITE_ASSET__235926af__"